angular
  .module('workflow')

  .directive('previewBilling', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        workflow: '=ngModel'
      },
      templateUrl: 'custom/workflow/views/partials/previewBilling.html'
    };
  });
